import { forwardRef } from 'react';

import { Button } from '..';
import { TProps } from '../types/TProps';

export const NeutralButtonChrome = forwardRef<HTMLButtonElement, TProps>(({ className, ...props }, ref) => (
  <Button ref={ref} className={['btn--neutral', className].filter(Boolean).join(' ')} {...props} />
));

NeutralButtonChrome.displayName = 'NeutralButtonChrome';
